<template>
    <div style="border: 1px solid transparent;">
        <div class="password-reset">
            <h1 class="title">密码修改</h1>
            <div class="password-reset-wrap">
                <div class="form-group">
                    <p>旧密码</p>
                    <input type="password" ref="oldpassworld" placeholder="请输入旧密码" v-model="oldPassword">
                </div>
                
                <div class="form-group">
                    <p>新密码</p>
                    <input type="password" ref="password" placeholder="请输入新密码" v-model="newPassword" @input="validPassword">
                    <!-- <p><label class="error">注：密码由6-16个字符组成，字母区分大小写，密码不能包含空格，不能包含非常用字符</label></p> -->
                </div>
                
                <div class="form-group">
                    <p>确认密码</p>
                    <input type="password" ref="vpassword" placeholder="请再次输入新密码" v-model="confirmPassword">
                </div>

                <div class="form-gorup button-group">
                    <el-button class="cancel" @click="cancel">取消</el-button>
                    <el-button class="confirm" @click="confirm" type="primary">确定修改</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            }
        },
        mounted(){ },
        methods: {
            validPassword(){
                
            },
            cancel(){
                this.$store.commit('fadeOutComponent')
            },
            confirm(){
                var test = /^(\w){6,16}$/;
                if(!test.test(this.newPassword)){
                    this.$e('请设置6-16位新密码!')
                    this.$refs['newPassword'].focus()
                    return
                }

                if(this.oldPassword == this.newPassword){
                    this.$message({type: 'warning', message: '旧密码不能和新密码相同！'})
                    return;
                }

                if(this.newPassword != this.confirmPassword){
                    this.$message({type: 'warning', message: '请输入相同的新密码'})
                    this.$refs['vpassword'].focus()
                    return;
                }

                if(this.oldPassword == ''){
                    this.$message({type: 'warning', message: '请输入旧密码'})
                    this.$refs['oldpassworld'].focus()
                    return;
                }
                var  username = this.login;
                this.$http.post('api/user/repassword', {
                    username:this.$store.state.username,
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword
                }).then( res => {
                    this.$message({type: 'success', message: '修改成功'})
                    this.$store.commit('fadeOutComponent')
                    this.$util.setCookie('auth', res, 3)
                    this.$nextTick(() => {
                        this.$router.push('/now/area')
                    })
                }).catch( ({msg}) => {
                    this.$e(msg)
                })
            }
        }
    }    
</script>



// WEBPACK FOOTER //
// src/component/base-password.vue